{
  "one": "Site",
  "loading": "Loading sites…",
  "add": "Add a site",
  "addFirst": "Add the first site",
  "emptyTitle": "No sites yet",
  "emptyHint": "A site is a physical location with its own network segment. The network map starts there, and that is where an agent gets installed.",
  "loadFailed": "Could not load the sites",
  "loadFailedHint": "{{reason}} Check the connection to the server and try again.",
  "editAria": "Edit site {{name}}",
  "editTitle": "Edit the name and description",
  "deleteAria": "Delete site {{name}}",
  "deleteTitle": "Delete the site",
  "deleteConfirm": "Delete site “{{name}}”?",
  "column": {
    "name": "Site",
    "description": "Description",
    "createdAt": "Created",
    "actions": "Actions"
  },
  "form": {
    "name": "Name",
    "namePlaceholder": "Lenina street warehouse",
    "description": "Description",
    "optional": "optional",
    "saving": "Saving…",
    "creating": "Creating…",
    "create": "Create"
  }
}
